
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --sic-hero--landing-image-overhang-xs-sm:clamp(
    6.625rem,
    6.6178rem + 11.4733vw,
    12.125rem
  );
  --sic-hero--landing-image-overhang-md:clamp(
    12.125rem,
    -2.5765rem + 30.5882vw,
    17rem
  );
  --sic-hero--landing-image-overhang-lg-xl:clamp(
    4.813rem,
    3.4536rem + 2.122vw,
    6rem
  );
  --sic-hero--landing-image-overhang-xxl:clamp(
    9rem,
    3.2737rem + 8.9385vw,
    9rem
  );
}
.landing-hero-wrapper{
  padding-top:var(--sic-hero--landing-image-overhang-xs-sm);
}
.hero-wrapper{
  display:flex;
  flex-direction:column;
  width:100%;
}
.hero-image{
  margin-top:calc(var(--sic-hero--landing-image-overhang-xs-sm) * -1);
  border-radius:var(--border-radius-rounded-default);
  z-index:3;
  overflow:hidden;
  position:relative;
  display:flex;
}
.hero-image div{
    width:100%;
  }
[cloned-slot-name='hero-image']{
  display:flex;
}
img{
  height:100%;
  width:100%;
  object-fit:cover;
  display:flex;
  flex-grow:auto;
}
.text-wrapper{
  display:flex;
  position:relative;
  margin:0;
  z-index:2;
  flex-direction:column;
  justify-content:center;
  align-items:flex-start;
  margin:var(--spacing-04) 0 var(--spacing-08);
}
.text{
  display:flex;
  flex-direction:column;
  position:relative;
  color:var(--color-neutral-white);
  row-gap:var(--spacing-02);
  margin-bottom:var(--spacing-06);
}
.eyebrow [cloned-slot-name='eyebrow']{
  font-size:var(--headline-eyebrow-font-size);
  line-height:var(--headline-eyebrow-line-height);
  margin-bottom:var(--spacing-02);
  letter-spacing:0.5px;
}
.heading [cloned-slot-name='heading']{
  color:var(--color-neutral-white);
}
.body [cloned-slot-name='body']{
  color:var(--color-neutral-white);
  font-size:var(--body-03-font-size);
}
.hero-wrapper .range2 .text{
    row-gap:var(--spacing-02);
  }
.hero-wrapper .range2 .text-wrapper{
    margin:var(--spacing-06) 0 var(--spacing-08);
  }
.landing-hero-wrapper.range3{
  padding-top:var(--sic-hero--landing-image-overhang-md);
}
.hero-wrapper .range3 .hero-image{
    margin-top:calc(var(--sic-hero--landing-image-overhang-md) * -1);
  }
.hero-wrapper .range3 .text-wrapper{
    margin:var(--spacing-06) var(--spacing-04) var(--spacing-08) var(--spacing-04);
  }
.hero-wrapper .range3 .text{
    row-gap:var(--spacing-04);
  }
.landing-hero-wrapper.range4{
  padding-bottom:var(--sic-hero--landing-image-overhang-lg-xl);
  padding-top:0;
}
.hero-wrapper .range4{
  display:flex;
  flex-direction:row;
  column-gap:var(--spacing-08);
}
.hero-wrapper .range4 .hero-image{
    margin-bottom:calc(var(--sic-hero--landing-image-overhang-lg-xl) * -1);
    margin-top:0;
    width:55%;
  }
.hero-wrapper .range4 .text-wrapper{
    flex:1 0 45%;
    padding:var(--spacing-16) 0;
  }
.hero-wrapper .range4 .text{
    row-gap:var(--spacing-04);
    margin-bottom:var(--spacing-08);
  }
.landing-hero-wrapper.range5{
  padding-bottom:var(--sic-hero--landing-image-overhang-lg-xl);
  padding-top:0;
}
.hero-wrapper .range5{
  display:flex;
  flex-direction:row;
  column-gap:var(--spacing-08);
}
.hero-wrapper .range5 .hero-image{
    width:68%;
    margin-top:0;
    margin-bottom:calc(var(--sic-hero--landing-image-overhang-lg-xl) * -1);
  }
.hero-wrapper .range5 .text-wrapper{
    flex:1 0 32%;
    row-gap:var(--spacing-04);
    column-gap:var(--spacing-20);
    padding:var(--spacing-16) 0;
  }
.hero-wrapper .range5 .text{
    row-gap:var(--spacing-04);
  }
.landing-hero-wrapper.range6{
  padding-bottom:var(--sic-hero--landing-image-overhang-xxl);
  padding-top:0;
}
.hero-wrapper .range6{
  display:flex;
  flex-direction:row;
  column-gap:15%;
}
.hero-wrapper .range6 .hero-image{
    width:68%;
    margin-bottom:calc(var(--sic-hero--landing-image-overhang-xxl) * -1);
    margin-top:0;
  }
.hero-wrapper .range6 .text-wrapper{
    flex:1 0 32%;
    column-gap:var(--spacing-20);
    padding:var(--spacing-16) 0;
  }
.hero-wrapper .range6 .text{
    row-gap:var(--spacing-04);
    margin-bottom:var(--spacing-08);
  }
`;